<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2022-12-03 13:07:27
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-05-06 16:14:45
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/supplierManagement/components/baseInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div class="contents">
    <div class="head-title">基本信息</div>
    <div class="info-wrap">
      <p class="company-name">{{ companyInfo.companyName }}</p>
      <div>
        <div class="left">
          <ul>
            <li>
              <span class="item">易派客标准指数ESI（会员）:</span
              ><span class="item-1">{{ companyStandardInfo.strength }}</span>
            </li>
            <li>
              <span class="item">法人信用认证:</span
              ><span class="item-1">{{ companyInfo.creditGrade }}</span>
            </li>
            <li>
              <span class="item">产品质量评价:</span
              ><span class="item-1">{{
                companyStandardInfo.productGrade
              }}</span>
            </li>
            <li class="flex-line">
              <span class="item">履约动态考评:</span>
              <div>
                <el-rate
                  :colors="colors"
                  :max="5"
                  :disabled="true"
                  v-model="gradeId"
                />
              </div>
            </li>
            <li class="flex-line">
              <span class="item">市场业绩表现:</span>
              <div>
                <el-rate
                  :colors="color"
                  :max="5"
                  :disabled="true"
                  v-model="innovationEvaluate"
                />
              </div>
            </li>
          </ul>
        </div>
        <div class="middle">
          <p>营业执照附件：</p>
          <div>
            <div @click="showBigImg" v-if="!this.companyOtherInfo.isPdf">
              <el-image
                :src="enclosureImg"
                :preview-src-list="[bigEnclosureImg]"
                class="license-img"
              ></el-image>
            </div>

            <img
              v-else
              class="license-img"
              @click="clickPdfFile"
              :src="enclosureImg"
              alt
            />
          </div>
        </div>
        <!-- <div class="right">
          <p>行政许可列表：</p>
          <div>
            <img src="" alt="" />
            <img src="" alt="" />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api/user';
export default {
  props: {
    companyInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    companyStandardInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    companyOtherInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      colors: ['#F78515', '#F78515', '#F78515'],
      color: ['#55B3CF', '#55B3CF', '#55B3CF'],
      enclosureImg: require('@/assets/img/common/license.jpg'),
      bigEnclosureImg: '',
    };
  },

  components: {},

  computed: {
    gradeId: {
      get() {
        return this.companyStandardInfo.gradeId
          ? parseInt(this.companyStandardInfo.gradeId)
          : 0;
      },
      set() {},
    },
    innovationEvaluate: {
      get() {
        return this.companyStandardInfo.innovationEvaluate
          ? parseInt(this.companyStandardInfo.innovationEvaluate)
          : 0;
      },
      set() {},
    },
  },

  created() {},
  methods: {
    // 打开pdf
    async clickPdfFile() {
      let data = await api.getSupplierLicence({
        // 获得市场执照附件
        filePath: this.companyOtherInfo.administrative[0],
      });

      window.open(data.data);
    },
    async showBigImg() {
      console.log(234);
      let data = await api.getSupplierLicence({
        // 获得市场执照附件
        filePath: this.companyOtherInfo.administrative[0],
      });
      this.bigEnclosureImg = data.data;
    },
  },
};
</script>
<style lang="scss" scoped>
.contents {
  // width: 1010px;
  // margin:0 auto;
  border: 1px solid #d9d9d9;
  margin-bottom: 20px;
  .head-title {
    color: #333;
    font-size: 14px;
    background: #f5f5f5;
    padding: 15px 20px;
  }
  .info-wrap {
    padding-left: 20px;
    .company-name {
      font-size: 16px;
      color: #333;
      margin-top: 20px;
      font-weight: 500;
      margin-bottom: 20px;
    }
    & > div {
      display: flex;
    }
    .left {
      width: 40%;
      ul {
        li {
          line-height: 1;
          margin-bottom: 20px;
        }
      }
      .item {
        display: inline-block;
        color: #333;
        font-size: 14px;
        //   width: 40%;
        text-align: left;
        margin-right: 10px;
      }
      .item-1 {
        color: #333;
        font-size: 14px;
      }
    }
    .middle {
      width: 20%;
      p {
        font-size: 14px;
        color: #333;
      }
      img {
        width: 100px;
        height: 100px;
      }
      .license-img {
        width: 88px;
        height: 130px;
        cursor: pointer;
      }
    }
    .right {
      width: 40%;
      p {
        font-size: 14px;
        color: #333;
      }
    }
    .flex-line {
      display: flex;
    }
  }
}
</style>
